import { makeStyles } from '@material-ui/core/styles';

export const useDetailStyles = makeStyles((theme) => ({
    selectedAuthType: {
        width: 200,
    },
    serverPortContainer: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
    },
    samlGroupConfigurationSpacer: {
        marginBottom: theme.spacing(2),
    },
    samlXMLContainer: {
        marginTop: theme.spacing(5),
    },
}));
